var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kbank-payment-page"},[(!_vm.ready)?_c('div',{staticClass:"kbank-payment-page__loading"},[_c('v-progress-circular',{attrs:{"size":72,"width":6,"color":"primary","indeterminate":""}}),_c('p',[_vm._v("กำลังเชื่อมต่อระบบชำระเงินที่ปลอดภัย…")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }